import {Component, Input, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {Configuration} from '@shared/models/configuration';
import {IPlatformToolComponent, IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {PlatformCommandResponse} from '@shared/commands/command-base';

/** Firm-only platform tool body: virtual grid for sub-account users (SmartGrid SubAccountUsers + ItemsUrl). */
@Component({
  standalone: false,
  selector: 'particle-firm-sub-account-users-grid-host',
  templateUrl: './sub-account-users-grid-host.component.html',
  styleUrls: ['./sub-account-users-grid-host.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FirmSubAccountUsersGridHostComponent implements OnInit, OnDestroy, IPlatformToolComponent {
  @Input() magicLinkModel: MagicLinkModel;
  @Input() handler: IPlatformToolHandler;
  @Input() selectedTab: TabModel;
  @Input() invalidateSubject: InvalidateSubject;

  readonly sourceKey = 'SubAccountUsers';
  sortFieldKey = 'ModifiedDate';
  sortDirection = 'desc';
  api = '';
  serviceName = '';
  gridParameters: Record<string, unknown> = {};
  /** Deferred until `onLoad` so `selectedTab` and SmartGrid `ACCOUNT_ID` exist before the virtual grid runs `ngOnInit`. */
  gridHostReady = false;

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  /**
   * Tab bar assigns `selectedTab` only after `createComponent()`; `ngOnInit` runs too early, so SmartGrid
   * `Parameters.ACCOUNT_ID` and the ItemsUrl `?accountId=` placeholder must be set here.
   */
  onLoad(): void {
    this.applySortAndServiceFromTab();
    this.applySmartGridAccountParameter();
    const id = this.resolveAccountId();
    this.gridParameters = {
      ...(this.selectedTab?.tabData as Record<string, unknown> | undefined),
      ACCOUNT_ID: id,
    };
    this.gridHostReady = true;
  }

  onBeforeExecuteNextCommand(): boolean {
    return true;
  }

  onAfterExecuteNextCommand(_nextCommandResponse: PlatformCommandResponse): void {
  }

  onBeforeExecutePreviousCommand(): boolean {
    return true;
  }

  onAfterExecutePreviousCommand(_previousCommandResponse: PlatformCommandResponse): void {
  }

  onValueChange($event: unknown): void {
    this.handler?.valueChanged($event);
  }

  private applySmartGridAccountParameter(): void {
    const id = this.resolveAccountId();
    const cfg = Configuration.getSmartGridConfig(this.sourceKey);
    if (cfg?.Parameters) {
      cfg.Parameters['ACCOUNT_ID'] = id;
    }
  }

  private applySortAndServiceFromTab(): void {
    const td = this.selectedTab?.tabData as Record<string, unknown> | undefined;
    if (!td) {
      return;
    }
    const sortKey = td['SortFieldKey'] ?? td['sortFieldKey'];
    const sortDir = td['SortDirection'] ?? td['sortDirection'];
    const apiVal = td['Api'] ?? td['api'];
    const svc = td['ServiceName'] ?? td['serviceName'];
    if (sortKey) {
      this.sortFieldKey = String(sortKey);
    }
    if (sortDir) {
      this.sortDirection = String(sortDir);
    }
    if (apiVal) {
      this.api = String(apiVal);
    }
    if (svc) {
      this.serviceName = String(svc);
    }
  }

  private resolveAccountId(): string {
    const td = this.selectedTab?.tabData as Record<string, unknown> | undefined;
    if (!td) {
      return '';
    }
    const v = td['ACCOUNT_ID'] ?? td['accountId'] ?? td['AccountId'];
    return v != null && v !== '' ? String(v) : '';
  }
}
